// Utils
import { prop, propIn } from '../../../common/utils/immutableHelper';

// Property accessors
export const getPoiId = prop('id');
export const getPoiType = prop('poiType');
export const getPoiCurrentBoardId = prop('currentBoardId');
export const getPoiSection = prop('section');
export const getPoiSeen = prop('seen');
export const getPoiTargetRect = prop('targetRect');
export const getPoiTargetPoint = prop('targetPoint');
export const getPoiCount = propIn(['data', 'count']);

export const getPoiElementId = propIn(['data', 'elementId']);
export const getPoiCommentId = propIn(['data', 'commentId']);

// Only for element change POIs
export const getPoiNotificationId = propIn(['data', 'notificationId']);
export const getPoiIsElementChange = propIn(['data', 'isElementChange']);
export const getPoiIsCommentActivity = propIn(['data', 'isCommentActivity']);

// Connections store
export const getPoiMap = (state) => state.get('pointsOfInterest');
